<script>
export default {
  props: {
    text: {
      type: String,
      default: ''
    },
    faClass: {
      type: String,
      default: 'arrow-left'
    },
    faPosition: {
      type: String,
      default: 'right'
    },
    bootstrapClass: {
      type: String,
      default: 'bg-primary'
    },
    title: {
      type: String,
      default: ''
    }
  }
}
</script>
